import { combineReducers } from 'redux';
import { TableNames } from '../../lib/constants';
import * as types from '../actions/actionTypes';

import authentication from './AuthenticationReducer';
import settings from './SettingsReducer';
import systemSettings from './SystemSettingsReducer';
import suggestions from './SuggestionsReducer';
import applications from './ApplicationsReducer';
import checkPrinting from './CheckPrintingReducer';
import createApplication from './CreateApplicationReducer';
import recipientAccounts from './RecipientAccountsReducer';
import recipientAccountDetails from './RecipientAccountDetailsReducer';
import references from './ReferencesReducer';
import duplicateRecipients from './DuplicateRecipientsReducer';
import sidebarFilters from './SidebarFiltersReducer';
import campaigns from './CampaignsReducer';
import campaignDetails from './CampaignDetailsReducer';
import campaignLists from './CampaignListsReducer';
import campaignListDetails from './CampaignListDetailsReducer';
import campaignListApplications from './CampaignListApplicationsReducer';
import externalCampaignList from './ExternalCampaignListReducer';
import funds from './FundsReducer';
import fundDetails from './FundDetailsReducer';
import reconciliationReports from './ReconciliationReportsReducer';
import tableReducer from './TableReducer';
import infiniteListReducer from './InfiniteListReducer';
import userProfile from './UserProfileReducer';
import users from './UsersReducer';
import { reducer as toastr } from 'react-redux-toastr';
import utils from './UtilsReducer';

const appReducer = combineReducers({
    authentication,
    settings,
    systemSettings,
    suggestions,
    applications,
    checkPrinting,
    recipientAccounts,
    recipientAccountDetails,
    references,
    duplicateRecipients,
    createApplication: createApplication,
    applicationsSidebarFilters: sidebarFilters(TableNames.Applications),
    recipientsSidebarFilters: sidebarFilters(TableNames.Recipients),
    campaigns,
    campaignDetails,
    campaignLists,
    campaignListDetails,
    campaignListApplications,
    externalCampaignList,
    funds,
    fundDetails,
    reconciliationReports,
    userProfile,
    users,
    toastr,
    utils,

    applicationsTable: tableReducer(TableNames.Applications),
    recipientsTable: tableReducer(TableNames.Recipients),
    referencesTable: tableReducer(TableNames.References),
    duplicateRecipientsTable: tableReducer(TableNames.DuplicateRecipients),
    campaignsTable: tableReducer(TableNames.Campaigns),
    campaignListsTable: tableReducer(TableNames.CampaignLists),
    campaignListParticipantsTable: tableReducer(TableNames.CampaignListParticipants),
    campaignListApplicationsTable: tableReducer(TableNames.CampaignListApplications),
    campaignDetailsListsTable: tableReducer(TableNames.CampaignDetailsLists),
    campaignDetailsIndividualsTable: tableReducer(TableNames.CampaignDetailsIndividuals),
    accountingTransactionsTable: tableReducer(TableNames.AccountingTransactions),
    accountingOutsideTransactionsTable: tableReducer(TableNames.AccountingOutsideTransactions),
    usersTable: tableReducer(TableNames.Users),

    externalCampaignListParticipantsList: infiniteListReducer(TableNames.ExternalCampaignListParticipants),
    reconciliationPaymentsTable: infiniteListReducer(TableNames.ReconciliationPayments),
    reconciliationCreditsTable: infiniteListReducer(TableNames.ReconciliationCredits),
    receivingParticipantsTable: infiniteListReducer(TableNames.ReceivingParticipants)
});

const rootReducer = (state, action) => {
    if(action.type === types.LOGOUT_SUCCESS) {
        state = undefined;
    }

    return appReducer(state, action);
}

export default rootReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js